/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Formik, Field } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import { differenceInCalendarDays, isAfter } from 'date-fns';
import Layout from 'components/Layout';
import Colors from 'constants/Colors';
import { ButtonContent } from './styles';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import StepNavigation from 'components/StepNavigation'
import {
  Table,
  DialogCalculation,
  NotesModal,
  Button,
  ButtonContainer,
  LostCancelButton,
  FormSectionGlobal as FormSection,
  HasPermission,
  MobileTable,
  Clauses,
  FormContainer
} from '@fitinsur/components'
import TableCalculationList from 'components/TableCalculationList'
import {
  AddButton,
  Content,
  TitleBar,
  TitleInfo,
  TitleAlter,
  Option,
  BrokerContainer,
  CoverageContainer,
  Plan,
  TextQuestion,
  ClausesContainer,
  ClauseContent,
  RefreshButon
} from './styles';
import Row from "components/Grid/Row";
import Col from "components/Grid/Col";
import BrokingSummary from 'components/BrokingSummary';
import MasksHelper from 'utils/src/masks';
import Icon from 'components/Icon'
import * as yup from 'yup';
import { CheckBox } from "@fitinsur/components";
import { useGetDocuments, useGetDocuments as useGetDocumentsExpired } from 'services/DocumentsService';
import { useRecalculateSync, useComissionRate, useCalculateCancellationSync } from 'services/PremiumCalculationService';
import {
  LoaderContext
} from '@fitinsur/contexts'
import {
  useGetOperationAsync,
  useResetOperationState,
  useUpdateOperationSync,
  useCheckMaxOperationAmount
} from '@fitinsur/services/OperationService';
import { useVerifyRiskAcceptance } from 'services/RiskAcceptanceService';
import { useGetQuestionnaireAnswer, useSaveQuestionnaireAnswer, useSaveQuestionnaireAnswerSync } from 'services/QuestionnaireAnswerService';
import { useGenerateQuoteAndClausesAsync } from 'services/QuoteService';
import {
  useUpdateDocumentsClausesSync
} from 'services/ClausesService';
import {
  useRequestSompoGetInternalProcessNumber,
  useRequestSompoGetInstallments
} from 'services/IssueService';
import {
  useGetLimitConsumption,
  useCheckConsumption
} from '@fitinsur/services/CreditLimitService';
import { onValidationError, dateDiffInDay } from 'containers/edit/handleQuestionChange';
import { cloneDeep, isEmpty } from 'lodash';
import moment from 'moment';
import { isNumber } from '@fitinsur/utils';

export default function Plans({ permissions, ...props }) {
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();

  const { updateIsLoadingStatus } = useContext(LoaderContext);
  const [notesModal, setNotesModal] = useState(false);
  const validationSchema = useRef(yup.object().shape({}));
  const loading = useContext(GlobalLoaderContext);
  const history = useHistory();
  const goToNextPage = useRef(false);
  const mc = new MessageCenter();
  const formikRef = useRef({});
  const getQuestionnaire = useRef(false);
  const [operation, setOperation] = useState({});
  const [isBound, setIsBound] = useState(true);
  const [selectedOption, setSelectedOption] = useState(null);
  const handleBack = () => history.goBack();
  const [isInAnalysis, setIsInAnalysis] = useState(null);
  const [clauseGroups, setClauseGroups] = useState([]);
  const [selectedClauses, setSelectedClauses] = useState([]);
  const [questionnaire, setQuestionnaire] = useState([]);
  const [fullCoverageList, setFullCoverageList] = useState([]);
  const [choosedDeductible, setChoosedDeductible] = useState(0);
  const [groupDeductible, setGroupDeductible] = useState([]);
  const [hasCoverageCalc, setHasCoverageCalc] = useState(false);
  const [idProductPlan, setIdProductPlan] = useState(0);
  const [minCommissionValue, setMinCommissionValue] = useState(0);
  const [maxComissionValue, setMaxCommissionValue] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const recalculateParameters = useRef([]);
  const questionMappingAdhocParameters = useRef([]);
  const [idProductPlanMetadata, setIdProductPlanMetadata] = useState(0);
  const [tomadorInfo, setTomadorInfo] = useState({});
  const [clausesLoading, setClausesLoading] = useState(false);
  const [previousCoverageCalcList, setPreviousCoverageCalcList] = useState([]);
  const [reloadClauses, setReloadClauses] = useState(null);
  const [overwriteQstValues, setOverwriteQstValues] = useState({});
  const [coverageCalcList, setCoverageCalcList] = useState([{
    coverageCalc: [{
      coverageLimit: "0",
      coveragePremium: "0",
      coverageAmount: "0",
      coverageComissionRate: "0",
      coverageComission: "0",
      coverageTax: "0",
      coverageAmountTaxLess: "0",
      deductibleDescription: "",
      coverageItems: []
    }]
  }]);
  const finishedAnalysis = questionnaire.find(qst => qst.idQuestion === 1603)?.idAnswerOption === 7220;

  const SECTIONS = {
    QUOTE_LETTER: { name: 'QUOTE_LETTER', isMultiple: false, isRisk: false },
    PLANS: { name: 'PLANS', isMultiple: false, isRisk: false },
    PLANS_PAYMENT: { name: 'PLANS_PAYMENT', isMultiple: false, isRisk: false }
  };

  const {
    data: useGetDocumentsData,
    loading: useGetDocumentsLoading,
    error: useGetDocumentsError,
    status: useGetDocumentsStatus,
    request: useGetDocumentsRequest
  } = useGetDocuments(props.match.params.idOperation);

  const {
    data: useGenerateQuoteData,
    loading: useGenerateQuoteLoading,
    error: useGenerateQuoteError,
    status: useGenerateQuoteStatus,
    request: useGenerateQuoteRequest
  } = useGenerateQuoteAndClausesAsync(props?.match?.params?.idOperation);

  const {
    data: useGetDocumentsExpiredData,
    loading: useGetDocumentsExpiredLoading,
    error: useGetDocumentsExpiredError,
    status: useGetDocumentsExpiredStatus,
    request: useGetDocumentsExpiredRequest
  } = useGetDocuments(props.match.params.idOperation);

  const {
    data: useRecalculateSyncData,
    loading: useRecalculateSyncLoading,
    error: useRecalculateSyncError,
    status: useRecalculateSyncStatus,
    request: useRecalculateSyncRequest
  } = useRecalculateSync(props.match.params.idOperation);

  const {
    data: useCalculateCancellationSyncData,
    loading: useCalculateCancellationSyncLoading,
    error: useCalculateCancellationSyncError,
    status: useCalculateCancellationSyncStatus,
    request: useCalculateCancellationSyncRequest
  } = useCalculateCancellationSync(props.match.params.idOperation);

  const {
    data: useComissionRateData,
    loading: useComissionRateLoading,
    error: useComissionRateError,
    status: useComissionRateStatus,
    request: useComissionRateRequest
  } = useComissionRate(props.match.params.idOperation);

  const {
    loading: useUpdateOperationLoading,
    request: useUpdateOperationRequest
  } = useUpdateOperationSync(props.match.params.idOperation);

  const {
    data: useResetOperationStateData,
    loading: useResetOperationStateLoading,
    error: useResetOperationStateError,
    status: useResetOperationStateStatus,
    request: useResetOperationStateRequest,
  } = useResetOperationState(props.match.params.idOperation);

  const {
    loading: useGetOperationLoading,
    request: useGetOperationRequest
  } = useGetOperationAsync(props.match.params.idOperation);

  const {
    data: useVerifyRiskAcceptanceData,
    loading: useVerifyRiskAcceptanceLoading,
    error: useVerifyRiskAcceptanceError,
    status: useVerifyRiskAcceptanceStatus,
    request: useVerifyRiskAcceptanceRequest
  } = useVerifyRiskAcceptance(props.match.params.idOperation);

  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    error: useGetQuestionnairesAnswersError,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswer(props.match.params.idOperation);

  const {
    loading: useUpdateDocumentsClausesLoading,
    request: useUpdateDocumentsClausesRequest,
  } = useUpdateDocumentsClausesSync(props.match.params.idOperation);

  const {
    loading: useRequestSompoGetInternalProcessNumberLoading,
    request: useRequestSompoGetInternalProcessNumberRequest,
  } = useRequestSompoGetInternalProcessNumber();

  const {
    data: useSaveQuestionnaireAnswerData,
    loading: useSaveQuestionnaireAnswerLoading,
    error: useSaveQuestionnaireAnswerError,
    status: useSaveQuestionnaireAnswerStatus,
    request: useSaveQuestionnaireAnswerRequest,
  } = useSaveQuestionnaireAnswer(props?.match?.params?.idOperation);

  const {
    loading: useSaveQuestionnaireAnswerSyncLoading,
    request: useSaveQuestionnaireAnswerSyncRequest,
  } = useSaveQuestionnaireAnswerSync(props?.match?.params?.idOperation);

  const {
    loading: useRequestSompoGetInstallmentsLoading,
    request: useRequestSompoGetInstallmentsRequest,
  } = useRequestSompoGetInstallments();

  const {
    data: useGetLimitConsumptionData,
    loading: useGetLimitConsumptionLoading,
    error: useGetLimitConsumptionError,
    status: useGetLimitConsumptionStatus,
    request: useGetLimitConsumptionRequest,
  } = useGetLimitConsumption(props?.match?.params?.idOperation);

  const {
    data: useCheckConsumptionData,
    loading: useCheckConsumptionLoading,
    error: useCheckConsumptionError,
    status: useCheckConsumptionStatus,
    request: useCheckConsumptionRequest,
  } = useCheckConsumption(props?.match?.params?.idOperation);

  const {
    loading: useCheckMaxOperationAmountLoading,
    request: useCheckMaxOperationAmountRequest,
  } = useCheckMaxOperationAmount(props?.match?.params?.idOperation);

  const { value: creditLimits } = useGetLimitConsumptionData || {};
  const location = useLocation();

  // Redirecionamento para plans-rcg quando idProduct = 9004 e URL não contém "plans-rcg"
  useEffect(() => {
    const currentPath = location.pathname;
    const idProduct = props?.match?.params?.idProduct;
    const idOperation = props?.match?.params?.idOperation;
    
    if (idProduct === "9004" && !currentPath.includes("plans-rcg")) {
      history.replace(`/quote/plans-rcg/${idProduct}/${idOperation}`);
    }
  }, [location.pathname, props?.match?.params?.idProduct, props?.match?.params?.idOperation, history]);

  useEffect(() => {
    updateIsLoadingStatus(
      useGetDocumentsLoading ||
      useCheckConsumptionLoading ||
      useGetOperationLoading ||
      useResetOperationStateLoading ||
      useRecalculateSyncLoading ||
      useVerifyRiskAcceptanceLoading ||
      useGetQuestionnairesAnswersLoading ||
      useGetDocumentsExpiredLoading ||
      useGenerateQuoteLoading ||
      useUpdateDocumentsClausesLoading ||
      useUpdateOperationLoading ||
      useComissionRateLoading ||
      useSaveQuestionnaireAnswerLoading ||
      useRequestSompoGetInternalProcessNumberLoading ||
      clausesLoading ||
      useGetLimitConsumptionLoading ||
      useSaveQuestionnaireAnswerSyncLoading ||
      useCalculateCancellationSyncLoading ||
      useRequestSompoGetInstallmentsLoading ||
      useCheckMaxOperationAmountLoading
    )
  }, [
    useGetDocumentsLoading,
    useCheckConsumptionLoading,
    useGetOperationLoading,
    useResetOperationStateLoading,
    useRecalculateSyncLoading,
    useVerifyRiskAcceptanceLoading,
    useGetQuestionnairesAnswersLoading,
    useGetDocumentsExpiredLoading,
    useGenerateQuoteLoading,
    useUpdateDocumentsClausesLoading,
    useUpdateOperationLoading,
    useComissionRateLoading,
    useSaveQuestionnaireAnswerLoading,
    useRequestSompoGetInternalProcessNumberLoading,
    clausesLoading,
    useGetLimitConsumptionLoading,
    useSaveQuestionnaireAnswerSyncLoading,
    useCalculateCancellationSyncLoading,
    useRequestSompoGetInstallmentsLoading,
    useCheckMaxOperationAmountLoading
  ]);

  const handleCheckConsumption = async (isIssue = false) => {
    try {
      if (![26, 398].includes(operation?.idDomain)) return true;
      const { data: consumptionData } = await useCheckConsumptionRequest({}, { isIssue });
      return !!consumptionData?.value?.availableLimit;
    } catch (err) {
      console.log("error consumption", err)
      if (err?.response?.data?.errors?.length) {
        err?.response?.data?.errors.map(error => mc.error(error.message))
      } else {
        mc.error("Falha ao confirmar a sua cotação, tente novamente!")
      }
      return false;
    }
  }

  const handleCheckMaxOperationAmount = async () => {
    try {
      if (![26, 398].includes(operation?.idDomain)) return true;
      const { data: validationData } = await useCheckMaxOperationAmountRequest();
      return !!validationData?.value?.allowedOperationAmount;
    } catch (err) {
      if (err?.response?.data?.errors?.length) {
        err?.response?.data?.errors.map(error => mc.error(error.message))
      } else {
        mc.error("Falha ao confirmar a sua cotação, tente novamente!")
      }
      return false;
    }
  }

  const handleOperationInfo = () => {
    useGetOperationRequest(null, { loadLastDocument: true }).then(response => {
      let operationData;
      if (response.status === 200) {
        operationData = response.data?.value;
        setOperation(operationData);
        setIdProductPlanMetadata(operationData?.operationMetadata?.idProductPlanSelected);
        setIsBound([5, 2, 6, 133, 158, 187, 263, 104, 99, 159, 140, 177, 188, 198, 176, 403].includes(operationData?.idDomainStatus));
        useGetQuestionnairesAnswersRequest(null, { idDomainStatus: operationData?.idDomainStatus });

        if (operationData.idDomain === 400) {
          useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, questionMappingAdhoc: questionMappingAdhocParameters.current, idProductPlanSelected: idProductPlan }, { draft: true });
        }
      }
    });
  }

  const findChoosedDeductible = () => {
    if (fullCoverageList?.coverageCalcList) {
      let indexCoverageCalcList;
      fullCoverageList.coverageCalcList.map((coverage, index) => {
        if (coverage.idProductPlan === idProductPlanMetadata) {
          indexCoverageCalcList = index;
        }
      })
      if (indexCoverageCalcList) {
        setChoosedDeductible(indexCoverageCalcList);
      }
    }
  }

  useEffect(() => {
    if (!clausesLoading) {
      setReloadClauses(null);
      setOverwriteQstValues({});
    }
  }, [clausesLoading]);

  useEffect(() => {
    if (fullCoverageList) {
      groupingDeductible(fullCoverageList);
    }
  }, [fullCoverageList]);

  useEffect(() => {
    findChoosedDeductible()
  }, [idProductPlanMetadata, fullCoverageList]);

  useEffect(() => {
    formikRef.current.setFieldValue('optionDeductible', String(choosedDeductible))
  }, [choosedDeductible]);

  const groupingDeductible = (fullCoverageList) => {
    let deductibles = [], coverage;

    if (fullCoverageList?.coverageCalcList) {
      deductibles = fullCoverageList.coverageCalcList.map((cov, index) => {
        coverage = cov.coverageCalc ? cov.coverageCalc[0] : '';
        return {
          value: String(index),
          label: coverage.deductibleDescription
        }
      }).filter((item, index, self) => index === self.findIndex(arr => arr.label === item.label && arr.label === item.label));
    }

    setGroupDeductible(deductibles)
  }

  const handleSelectDeductible = deductible => {
    setChoosedDeductible(deductible || 0)
    formikRef.current.setFieldValue('optionDeductible', String(deductible || 0))
  };

  const handleCalculateCancellation = async (questionnaire, calculations, forceRefreshTotalPaid = false) => {
    if (![400, 398].includes(operation?.idDomain) || finishedAnalysis || goToNextPage.current) return;

    const totalPaidQuestion = questionnaire.find(question => question.idQuestion === 1842);
    const totalPaidPersonalized = questionnaire.find(qst => qst.idQuestion === 2066);

    if ((!totalPaidQuestion.answer || !Number(totalPaidQuestion.answer)) || forceRefreshTotalPaid) {
      try {
        const response = await useRequestSompoGetInstallmentsRequest({ idOperation: props.match.params.idOperation });
        if (response.status === 200) {
          if (!response.data?.ret_value?.installments?.length) {
            mc.error('Não identificamos o pagamento do prêmio dessa Apólice. Consultar a Célula de Atendimento Comercial - CAC');
            totalPaidQuestion.behaviorObject.isReadOnly = false;

            const answerOption = totalPaidPersonalized?.answerOptions.find(
              opt => opt.idAnswerOption === 7700 //yes
            );

            if (answerOption) {
              totalPaidPersonalized.answer = answerOption.dsAnswerOption;
              totalPaidPersonalized.idAnswerOption = answerOption.idAnswerOption;
            }
          } else {
            totalPaidQuestion.answer = String(response.data?.ret_value?.totalPaid || 0);
            formikRef.current?.setFieldValue(totalPaidQuestion.key, totalPaidQuestion.answer);
            totalPaidQuestion.behaviorObject.isReadOnly = true;

            const answerOption = totalPaidPersonalized?.answerOptions.find(
              opt => opt.idAnswerOption === 7701 //no
            );

            if (answerOption) {
              totalPaidPersonalized.answer = answerOption.dsAnswerOption;
              totalPaidPersonalized.idAnswerOption = answerOption.idAnswerOption;
            }
          }
          setQuestionnaire(questionnaire);
        }
      } catch (e) {
        mc.error('Não identificamos o pagamento do prêmio dessa Apólice. Consultar a Célula de Atendimento Comercial - CAC');
        totalPaidQuestion.behaviorObject.isReadOnly = false;

        const answerOption = totalPaidPersonalized?.answerOptions.find(
          opt => opt.idAnswerOption === 7700 //yes
        );

        if (answerOption) {
          totalPaidPersonalized.answer = answerOption.dsAnswerOption;
          totalPaidPersonalized.idAnswerOption = answerOption.idAnswerOption;
        }
        setQuestionnaire(questionnaire);
      }
    }

    if ([398].includes(operation?.idDomain)) return;

    let isProRata = false;
    const isProRataQuestion = questionnaire.find(question => question.idQuestion === 1856);
    if (isProRataQuestion?.idAnswerOption === 7470) {
      isProRata = true;
    }

    let disregardMinimumPremium = false;
    const disregardMinimumPremiumQst = questionnaire.find(qst => qst.idQuestion === 2437);
    if (disregardMinimumPremiumQst?.idAnswerOption === 8158) {
      disregardMinimumPremium = true;
    }

    await useCalculateCancellationSyncRequest({
      isProRata,
      disregardMinimumPremium,
      "questionMappingAdhoc": [
        {
          "mapName": "mapQuestion1864",
          "mapValue": calculations[0].previousCoverageAmount
        },
        {
          "mapName": "mapQuestion1833",
          "mapValue": questionnaire.find(question => question.idQuestion === 1833)?.answer || moment(new Date()).format('YYYY-MM-DD')
        },
        {
          "mapName": "mapQuestion1856",
          "mapValue": questionnaire.find(question => question.idQuestion === 1856)?.idAnswerOption || 7471
        },
        {
          "mapName": "mapQuestion1842",
          "mapValue": Number(questionnaire.find(question => question.idQuestion === 1842)?.answer || 0)
        },
      ]
    });

    useGetDocumentsRequest(null, { idDomain: 261 });
  }

  const handleGetQuote = async (documentCoverageList, previousCalculation) => {
    if (!questionnaire?.length) return;

    documentCoverageList = cloneDeep(documentCoverageList);
    previousCalculation = cloneDeep(previousCalculation);

    let calculations = documentCoverageList.coverageCalcList[0].coverageCalc ? documentCoverageList.coverageCalcList[choosedDeductible].coverageCalc : documentCoverageList.coverageCalcList;

    calculations = calculations.map((calculation, index) => {
      calculation.productPlanName = documentCoverageList.coverageCalcList[0].coverageCalc ? documentCoverageList.coverageCalcList[choosedDeductible].idProductPlanName : documentCoverageList.idProductPlanName;
      calculation.idProductPlan = documentCoverageList.coverageCalcList[0].coverageCalc ? documentCoverageList.coverageCalcList[choosedDeductible].idProductPlan : documentCoverageList.idProductPlan;
      calculation.option = index;
      calculation.deductibleDescription = String(calculation.deductibleDescription || 0.0);
      calculation.coverageComissionRate = String(parseNumber(calculation.coverageComissionRate || 0.0) * 100)

      calculation.coverageItems = calculation.coverageItems.map((coverage) => {
        coverage.coveragePremium = String(coverage.coveragePremium || 0.0);
        coverage.coveragePremiumDiscountLess = String(coverage.coveragePremiumDiscountLess || 0.0);
        coverage.coveragePremiumTaxLess = String(coverage.coveragePremiumTaxLess || 0.0);
        coverage.coveragePremiumDiscountRate = String((coverage.coveragePremiumDiscountRate || 0.0) * 100);
        coverage.coverageDisabled = coverage.coverageDisabled;
        coverage.coverageRate = String(Number((coverage.coverageRate || 0.0) * 100).toFixed(2))
        coverage.coverageLimit = String(coverage.coverageLimit ? parseNumber(coverage.coverageLimit || 0.0) : parseNumber(calculation.coverageLimit));
        coverage.deductibleDescription = String(coverage.deductibleDescription ? coverage.deductibleDescription : "");
        coverage.coverageMaxLimClaim = String(coverage.coverageMaxLimClaim ? parseNumber(coverage.coverageMaxLimClaim || 0.0) : parseNumber(calculation.coverageMaxLimClaim));
        coverage.coverageMaxLimClaimRate = String(coverage.coverageMaxLimClaimRate ? parseNumber(coverage.coverageMaxLimClaimRate || 0.0) * 100 : (coverage.coverageMaxLimClaim / coverage.coverageLimit) * 100);
        return coverage;
      });
      return calculation;
    })

    const endorsementCoverageAmount = Number((calculations[0].adjustmentCoverageAmount || 0).toFixed(2));
    const endorsementCoverageAmountRaw = Number((calculations[0].adjustmentCoverageAmount || 0));
    const coverageRetentionRate = (calculations[0].coverageRetentionRate || 0);
    const coverageRetentionAmount = Number((calculations[0].coverageRetentionAmount || 0).toFixed(2));
    const coverageRetentionRatePeriod = (calculations[0].coverageRetentionRatePeriod || 0);
    const hasPreviousDiffMinimumPremiumIssued = calculations[0]?.hasPreviousDiffMinimumPremiumIssued;

    const endorsementCoverageAmountAnswer = questionnaire.find(
      qst => qst.idQuestion === 1843
    )?.answer;
    const changeInValueEndorsementCoverageAmount = (
      endorsementCoverageAmountAnswer &&
      Number(endorsementCoverageAmountAnswer) != endorsementCoverageAmountRaw
    );

    let flagReloadClauses = false;
    const overwriteQst = {};
    setQuestionnaire(questionnaire.map(qst => {
      if (qst.idQuestion === 1843) {
        qst.answer = String(endorsementCoverageAmountRaw);
        formikRef.current?.setFieldValue(qst.key, qst.answer);

        if (operation?.idDomain === 400) {
          overwriteQst[qst.idQuestion] = endorsementCoverageAmount;
        }
      }

      if (qst.idQuestion === 1841) {
        qst.answer = String(coverageRetentionAmount);
        formikRef.current?.setFieldValue(qst.key, qst.answer);
      }

      if (qst.idQuestion === 1839) {
        const proRataQuestion = questionnaire.find(q => q.idQuestion === 1856);
        qst.visibleQuestion = proRataQuestion?.idAnswerOption === 7471;
      }

      if (qst.idQuestion === 1840) {
        const proRataQuestion = questionnaire.find(q => q.idQuestion === 1856);
        qst.visibleQuestion = proRataQuestion?.idAnswerOption === 7471;
        qst.answer = String(coverageRetentionRate * 100);
        formikRef.current?.setFieldValue(qst.key, qst.answer);
      }

      if (qst.idQuestion === 1842 && operation.idDomain === 398) {
        qst.sequenceQuestion === 999999;
      }

      if (qst.idQuestion === 1884 && operation.idDomain === 398) {
        qst.answer = String(calculations[0].previousCoverageAmount || 0);
        formikRef.current?.setFieldValue(qst.key, qst.answer);
      }

      if (qst.idQuestion === 1844) {
        let idAnswerOption = endorsementCoverageAmount === 0 ? 7611 : endorsementCoverageAmount > 0 ? 7457 : 7458;
        const answerOption = qst.answerOptions.find(opt => opt.idAnswerOption === idAnswerOption);

        if (
          (
            qst.idAnswerOption !== answerOption.idAnswerOption ||
            (answerOption.idAnswerOption === 7458 && changeInValueEndorsementCoverageAmount)
          ) && operation?.idDomain === 400
        ) {
          overwriteQst[qst.idQuestion] = {
            answer: answerOption.dsAnswerOption,
            idAnswerOption: answerOption.idAnswerOption
          };
          flagReloadClauses = true;
        }

        qst.answer = answerOption.dsAnswerOption;
        qst.idAnswerOption = answerOption.idAnswerOption;

        formikRef.current?.setFieldValue(qst.key, {
          idAnswerOption: qst.idAnswerOption,
          dsAnswerOption: qst.answer,
          resultValue: null
        });
      }

      if (qst.idQuestion === 1839) {
        const answerOption = qst.answerOptions.find(opt => opt.dsAnswerOption === coverageRetentionRatePeriod);
        if (answerOption) {
          qst.answer = answerOption.dsAnswerOption;
          qst.idAnswerOption = answerOption.idAnswerOption;

          formikRef.current?.setFieldValue(qst.key, {
            idAnswerOption: qst.idAnswerOption,
            dsAnswerOption: qst.answer,
            resultValue: null
          });
        }
      }

      if ([1859, 1860, 1861, 1862, 1863].includes(qst.idQuestion)) {
        qst.visibleQuestion = endorsementCoverageAmount < 0;
        qst.behaviorObject.sectionName = "PLANS_PAYMENT";
        qst.sequenceQuestion = 9999;
      }

      if (qst.idQuestion === 2437 && hasPreviousDiffMinimumPremiumIssued === false) {
        if (
          (operation?.idDomain === 398 && calculations[0]?.coverageAmount < 0) ||
          operation?.idDomain === 400
        ) {
          qst.visibleQuestion = true;
        }
      }

      return qst;
    }));

    if (flagReloadClauses) {
      setOverwriteQstValues(overwriteQst);
      setReloadClauses(flagReloadClauses);
    }

    if (!idProductPlan) {
      handleCalculateCancellation(questionnaire, calculations);
    }
    setIdProductPlan(calculations[0].idProductPlan);

    if (previousCalculation) {
      formikRef.current?.setFieldValue('previousCalculationList', calculations);
      setPreviousCoverageCalcList(calculations);
    } else {
      formikRef.current?.setFieldValue('calculationList', calculations);
      setCoverageCalcList(calculations);
    }
  }

  const parseNumber = (value) => {
    if (typeof (value) === 'string') {
      if (value.startsWith('%')) return Number(value.replaceAll('%', '').replaceAll(',', '.'))

      return Number(value.replaceAll('R$', '').replaceAll('.', '').replaceAll(',', '.'))
    }
    return value
  }

  async function handleVerifyPaymentOfEndorsementsToRefund(documentCoverageList) {
    let verifiedPayment = true;
    if (![398, 400].includes(operation?.idDomain)) return verifiedPayment;

    const isRefund = questionnaire.find(
      qst => qst.idQuestion === 1844
    )?.idAnswerOption === 7458;

    const coverageCalc = documentCoverageList?.coverageCalcList?.[0];
    const { previousCoverageAmount } = coverageCalc || {};

    const premiumPaid = parseFloat(questionnaire.find(qst => qst.idQuestion === 1842)?.answer || 0);

    const totalPremium = Math.trunc((previousCoverageAmount || 0) * 100) / 100;

    const policyNotPaid = Math.abs(Number((premiumPaid - totalPremium).toFixed(2))) > 0.01 && premiumPaid < totalPremium;

    setQuestionnaire(questionnaire.map(qst => {
      if (qst.idQuestion === 2439) {
        const answerOption = qst.answerOptions.find(opt =>
          opt.idAnswerOption === (policyNotPaid ? 8161 : 8160)
        );

        if (answerOption) {
          qst.answer = answerOption.dsAnswerOption;
          qst.idAnswerOption = answerOption.idAnswerOption;
        }
      }
      return qst;
    }));

    if (!isRefund) return verifiedPayment;

    let totalPaid = null;
    try {
      const response = await useRequestSompoGetInstallmentsRequest({ idOperation: props.match.params.idOperation });
      if (response.status === 200 && response.data?.ret_value?.installments?.length) {
        totalPaid = Math.trunc(parseFloat(response.data?.ret_value?.totalPaid || 0) * 100) / 100;
      }
    } catch (error) { }

    if (isNumber(totalPaid) && Math.abs(totalPaid - premiumPaid) > 0.01) {
      mc.error(`
        Valor do Prêmio Líquido Pago divergente do valor retornado pela API de parcelas, 
        use o ícone de atualização ao lado  do campo Prêmio Líquido Pago para sincronizar os valores.
      `);
      verifiedPayment = false;
      return verifiedPayment;
    }

    if (policyNotPaid) {
      mc.error(`
        Endosso ${operation?.idDomain === 400 ? 'de cancelamento' : 'com movimento'} não permitido. 
        Apólice possui pendências financeiras. 
      `);
      verifiedPayment = false;
    }
    return verifiedPayment;
  }

  useEffect(() => {
    if (!useGetDocumentsStatus) return;
    if (useGetDocumentsStatus === 200) {
      const [quoteRequestDocument] = useGetDocumentsData.value;
      setFullCoverageList(quoteRequestDocument.documentCoverageList);
      setHasCoverageCalc(quoteRequestDocument.documentCoverageList.coverageCalcList[0].coverageCalc)
      handleGetQuote(quoteRequestDocument.documentCoverageList);
    }
  }, [useGetDocumentsStatus, choosedDeductible])

  useEffect(() => {
    if (getQuestionnaire.current) return;
    if (isEmpty(permissions)) return;

    handleOperationInfo();
    useGetDocumentsExpiredRequest(null, { idDomain: 261, expiredDocumentsOnly: true })
    useGetLimitConsumptionRequest();
    useVerifyRiskAcceptanceRequest(null, { draft: true });
    formikRef.current.setFieldValue('optionDeductible', String(0))

    getQuestionnaire.current = true
  }, [permissions])


  useEffect(() => {
    if (idProductPlan) useComissionRateRequest(null, { idProduct: props.match?.params?.idProduct, idProductPlanSelected: idProductPlan });

  }, [idProductPlan])

  useEffect(() => {
    if (useComissionRateStatus === 200) {

      const { commissionValue, minCommissionValue } = useComissionRateData;

      setMinCommissionValue(minCommissionValue * 100);
      setMaxCommissionValue(commissionValue * 100);
    }
  }, [useComissionRateStatus]);

  useEffect(() => {
    if (useRecalculateSyncStatus === 200) {
      handleGetQuote(useRecalculateSyncData?.value)
    }
  }, [useRecalculateSyncStatus]);

  useEffect(() => {
    if (idProductPlan) useComissionRateRequest(null, { idProduct: props.match?.params?.idProduct, idProductPlanSelected: idProductPlan });

  }, [idProductPlan])

  useEffect(() => {
    if (useComissionRateStatus === 200) {

      const { commissionValue, minCommissionValue } = useComissionRateData;

      setMinCommissionValue(minCommissionValue * 100);
      setMaxCommissionValue(commissionValue * 100);
    }
  }, [useComissionRateStatus]);


  useEffect(() => {
    const loadQuestionnaire = async () => {
      if (useVerifyRiskAcceptanceStatus === 200 && useGetQuestionnairesAnswersStatus === 200) {
        const { riskDescription } = useVerifyRiskAcceptanceData?.value;

        let questionnaire = [];
        setQuestionnaire(questionnaire);
        await new Promise(resolve => setTimeout(() => resolve(), 500))

        questionnaire = [
          ...useGetQuestionnairesAnswersData?.value.persons,
          ...useGetQuestionnairesAnswersData?.value.operations,
          ...useGetQuestionnairesAnswersData?.value.payments,
          ...useGetQuestionnairesAnswersData?.value.risks
        ];

        const forceAnalysis = [398, 400].includes(operation?.idDomain) || questionnaire.find(question => question.idQuestion === 1602)?.idAnswerOption === 7218;
        const tomadorQuestion = questionnaire.find(question => question.idQuestion === 1392);

        if (tomadorQuestion?.answer) {
          try {
            const person = JSON.parse(tomadorQuestion.answer)

            fitinsur.setAuthToken(authContext.token);
            fitinsur
              .requestTomadores(person.id)
              .then((response) => response.json()).then((response) => {
                // if (response.ret_code !== 200) return;
                setTomadorInfo({
                  limitAvaliable: response.ret_value?.relationshipContent?.capacityExposure || 0,
                  limitConsumed: response.ret_value?.relationshipContent?.consumedCapacityExposure || 0,
                })
              });
          } catch (e) {
          }
        }

        setQuestionnaire(questionnaire.map(qst => {
          if (qst.idQuestion === 1202 || qst.idQuestion === 1203) {
            if (!qst.answer) qst.visibleQuestion = false;
            qst.behaviorObject.paddingRight = 0;
          } else if (qst.idQuestion === 1427) {
            qst.visibleQuestion = false;
          } else if ([1859, 1860, 1861, 1862, 1863].includes(qst.idQuestion)) {
            qst.behaviorObject.sectionName = "PLANS_PAYMENT";
            qst.sequenceQuestion = 9999;
          }

          return qst;
        }).sort((a, b) => a.sequenceQuestion - b.sequenceQuestion));

        setIsInAnalysis(riskDescription === 'Analisar' || forceAnalysis);
        useGetDocumentsRequest(null, { idDomain: 261 });

        if (questionnaire.find(qst => qst.idQuestion === 1603)?.idAnswerOption === 7220) {
          setOperation({
            ...operation, document: {
              ...operation.document,
              idDomainStatus: 16
            }
          });
        }
      }
    }

    loadQuestionnaire();
  }, [useVerifyRiskAcceptanceStatus, useGetQuestionnairesAnswersStatus]);

  const handlePermissionEdit = () => {
    return !isBound && permissions.NBI_REQUEST_APPROVE_REJECT;
  }

  useEffect(() => {
    function resize() {
      if (window.innerWidth < 576) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }
    resize();
    window.addEventListener('resize', resize);
    return () => {
      window.removeEventListener('resize', resize);
    }
  }, []);

  const buildValidation = (draft) => {
    const validationSchema = {};

    const questionnaire = handleSaveQuestionnaireAnswer(props.match.params.idOperation, true);

    let allQuestions = [...questionnaire];
    for (const question of allQuestions) {
      if (question.childrenQuestions?.length) allQuestions = [...allQuestions, ...question.childrenQuestions]
    }

    for (const question of allQuestions) {
      if (draft && ![1634, 1776, 1637].includes(question.idQuestion)) continue;
      if ([614].includes(question?.idDomainQuestion)) continue;
      if (!question?.key) continue;



      question?.childrenQuestions?.map(item => {
        if (item.visibleQuestion && item.fieldMask?.type == 'phone' && item.behaviorObject?.isRequired) {
          validationSchema[item.key] = yup.string().test({
            name: "answer-validation",
            message: "Telefone inválido",
            test: (value) => !!value && value.length >= 10
          })
        } else if (item.visibleQuestion && item.behaviorObject?.fieldMask == 'email') {
          if (item.answer) {
            validationSchema[item.key] = yup.string().email("E-mail inválido").required("Campo obrigatório")
          } else {
            if (item.behaviorObject?.isRequired) {
              validationSchema[item.key] = yup.string().email("E-mail inválido").required("Campo obrigatório")
            } else {
              validationSchema[item.key] = yup.string().notRequired();
            }
          }
        } else {
          validationSchema[item.key] = item.visibleQuestion && item.behaviorObject?.isRequired
            ? yup.string().test("answer-validation", "Campo obrigatório", function (value) {
              return !!item.answer;
            }) : yup.string().notRequired();
        }
      })

      if (question.visibleQuestion && question.behaviorObject?.isRequired && question.fieldMask?.type == 'phone') {
        validationSchema[question.key] = yup.string().test({
          name: "answer-validation",
          message: "Telefone inválido",
          test: (value) => !!value && value.length >= 10
        })
      } else if (question.visibleQuestion && question.behaviorObject?.fieldMask == 'email') {
        if (question.answer) {
          validationSchema[question.key] = yup.string().email("E-mail inválido").required("Campo obrigatório")
        } else {
          if (question.behaviorObject?.isRequired) {
            validationSchema[question.key] = yup.string().email("E-mail inválido").required("Campo obrigatório")
          } else {
            validationSchema[question.key] = yup.string().notRequired();
          }
        }
      } else {
        validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired
          ? yup.string().test("answer-validation", "Campo obrigatório", function (value) {
            return !!question.answer;
          }) : yup.string().notRequired();
      }
    }

    return yup.object().shape(validationSchema);
  }

  const handleGenerateQuote = async (values) => {

    buildValidation().validate(values, { abortEarly: false })
      .then(async () => {
        handleSaveQuestionnaireAnswer(props.match?.params?.idOperation)
      })
      .catch((e) => {
        onValidationError(e, mc, formikRef, questionnaire, [])
      })
  }

  const handleSaveQuestionnaireAnswer = (idOperation, onlyQuestions, formattedGroups) => {
    const body = { questionnaireAnswers: cloneDeep(questionnaire) };
    for (const [key, section] of Object.entries(SECTIONS)) {
      if (section.isMultiple) {
        let multipleFields = []
        switch (section.name) {
          default:
            multipleFields = [];
            break;
        }

        multipleFields.map(group => {
          if (group?.length) {
            const rootQuestion = group.find(question => !question.idQuestionRoot);
            const childrenQuestions = group.filter(question => question.idQuestionRoot);
            rootQuestion.childrenQuestions = childrenQuestions;
            if (!onlyQuestions || formattedGroups) {
              body.questionnaireAnswers = [...body.questionnaireAnswers, rootQuestion];
            } else {
              body.questionnaireAnswers = [...body.questionnaireAnswers, ...group];
            }
          }
        })
      }
    }

    body.questionnaireAnswers = body.questionnaireAnswers.filter(question => {
      return (question?.behaviorObject?.sectionName && SECTIONS[question?.behaviorObject?.sectionName]);
    });

    let childrenQuestionIds = [];
    for (const question of body.questionnaireAnswers) {
      if (question) {
        if (
          (
            question.idDomainQuestion === 270 ||
            question.idDomainQuestion === 271 ||
            (question.idDomainQuestion === 44 && typeof question.answer === 'object')
          ) && question.answer
        ) {
          try {
            question.answer = JSON.stringify(question.answer)
          } catch (e) {
          }
        }

        if (SECTIONS[question.behaviorObject?.sectionName] && SECTIONS[question.behaviorObject?.sectionName].isMultiple) {
          if (question?.childrenQuestions?.length) {
            const idQuestions = question.childrenQuestions.map(question => question.idQuestion);
            childrenQuestionIds = [...childrenQuestionIds, ...idQuestions];
          }
        } else {
          question.childrenQuestions = [];
        }
      }
    }

    body.questionnaireAnswers = body.questionnaireAnswers.filter(v =>
      !childrenQuestionIds.includes(v.idQuestion) &&
      v.idQuestion !== 1812
    );

    if (onlyQuestions) return body.questionnaireAnswers;

    useSaveQuestionnaireAnswerRequest(body.questionnaireAnswers);
  }

  const handleTotalPaidValidationEndorsements = () => {
    const totalPaid = questionnaire.find(qst => qst.idQuestion === 1843)?.answer;

    if (+totalPaid > 0 && operation?.idDomain === 400) {
      mc.error('Endosso de cancelamento não permitido, apólice possui pendências financeiras. Consultar a Célula de Atendimento Comercial – CAC.');
      return false;
    } else if (+totalPaid === 0 && operation?.idDomain === 398) {
      mc.error('Endosso com movimento não permitido, apólice não pode ter o Prêmio Total do Endosso com o valor zero.');
      return false;
    }

    return true;
  }

  useEffect(() => {
    if (useSaveQuestionnaireAnswerStatus === 200) {
      if (!goToNextPage.current) {
        mc.success('informações salvas com sucesso!');
        return history.push(operation?.idDomain === 26 || !operation?.idDomain ? '/list' : '/polices');
      }

      const questionnaireUpdated = handleSaveQuestionnaireAnswer(props.match.params.idOperation, true);

      const finishedQuestion = questionnaireUpdated.find(q => q.idQuestion == 1427 || q.idQuestion == 1603);
      const finishedAnalisys = finishedQuestion?.idAnswerOption === 7220 || finishedQuestion?.idAnswerOption === 6872;

      useGetQuestionnairesAnswersRequest(null, { idDomainStatus: operation?.idDomainStatus });

      const hasInternalProcessNumberAnswer = questionnaire.find(qst => qst.idQuestion === 3476)?.answer;
      console.log("hasInternalProcessNumberAnswer", hasInternalProcessNumberAnswer)
      if (!hasInternalProcessNumberAnswer) {
        useRequestSompoGetInternalProcessNumberRequest({ idOperation: props?.match?.params?.idOperation })
          .then(async (response) => {
            if (response.status !== 200) {
              return mc.error('Ocorreu um erro na requisição do sistema externo');
            }
            useGenerateQuoteRequest({ selectedClausesAdHock: selectedClauses, idDomainStatus: finishedAnalisys ? 16 : 19, idProductPlanSelected: idProductPlan }).then(async (response) => {
              if (response.status == 200) {
                if (operation?.idDomain === 400) {
                  await useUpdateOperationRequest({ idDomainStatus: 151 });
                }
                return history.push(`/quote/document/${props?.match?.params?.idProduct}/${props?.match?.params?.idOperation}`);
              }
            })
          }).catch((e) => {
            return mc.error('Ocorreu um erro na requisição do sistema externo');
          })
      } else {
        useGenerateQuoteRequest({ selectedClausesAdHock: selectedClauses, idDomainStatus: finishedAnalisys ? 16 : 19, idProductPlanSelected: idProductPlan }).then(async (response) => {
          if (response.status == 200) {
            if (operation?.idDomain === 400) {
              await useUpdateOperationRequest({ idDomainStatus: 151 });
            }
            return history.push(`/quote/document/${props?.match?.params?.idProduct}/${props?.match?.params?.idOperation}`);
          }
        })
      }
    }
  }, [useSaveQuestionnaireAnswerStatus]);

  useEffect(() => {
    buildValidation();
  }, [questionnaire]);

  return (
    <Layout
      title={"Analise da Cotação"}
      subtitle={`${operation?.productName || ""}`}
      idOperation={operation?.idOperation}
    >
      <Row>
        <Col>
          <StepNavigation
            stage={2}
            idOperation={props.match?.params?.idOperation}
            idProduct={props.match?.params?.idProduct}
            permissions={permissions}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <BrokingSummary
            history={history}
            idOperation={props.match?.params?.idOperation}
            idProduct={props.match?.params?.idProduct}
            permissions={permissions}
          />
        </Col>
      </Row>

      <Content>
        <Formik
          innerRef={formikRef}
          initialValues={{}}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize={true}
        >
          {({ values, setFieldValue, errors, setFieldError }) => {
            return (
              <Form onKeyDown={(e) => {
                if (e.key === 'Enter') e.preventDefault();
              }}>

                <CoverageContainer>
                  <NotesModal
                    title={'Informações Adicionais'}
                    textButtonConfirm={'Confirmar'}
                    textButtonCancel={'Cancelar'}
                    show={notesModal}
                    setModalShow={setNotesModal}
                    customCancelButton={[Colors.WHITE, Colors.PRIMARY1]}
                    idOperation={props.match?.params?.idOperation}
                    idQuestion={1812}
                    functionCallback={async () => {
                      if (operation?.idDomain !== 400) {
                        await useResetOperationStateRequest({ idDomainOrigin: 26 });
                      }

                      const { status } = await useUpdateOperationRequest({
                        idDomainStatus: operation?.idDomain === 26 ? 4 :
                          operation?.idDomain === 254 ? 443 :
                            operation?.idDomain === 398 ? 448 :
                              operation?.idDomain === 400 ? 447 :
                                null
                      });

                      if (status === 200) history.push(operation?.idDomain === 26 ? '/enquiries' : '/polices');
                    }}
                  />

                  {selectedOption != null && <DialogCalculation
                    show={true}
                    formikValues={values}
                    formikRef={formikRef}
                    setFieldValue={setFieldValue}
                    calcList={previousCoverageCalcList?.filter(calculations => calculations.coverageLimit)}
                    permissions={permissions}
                    selectedOption={selectedOption}
                    closeModal={() => {
                      setSelectedOption(null)
                    }}
                  />}

                  {isMobile
                    ? <MobileTable
                      formikValues={values}
                      formikRef={formikRef}
                      calcList={coverageCalcList.filter(calculations => calculations.coverageLimit)}
                      setFieldValue={setFieldValue}
                      history={history}
                      showAlterButton={isBound}
                      warrantyQuote
                      disabled={operation?.idDomain === 400 || isBound || !isInAnalysis || operation?.document?.idDomainStatus === 20 || operation?.document?.idDomainStatus === 16 || (!permissions.NBI_REQUEST_APPROVE_REJECT && operation?.document?.idDomainStatus === 19)}
                      newDisabled={operation?.idDomain === 400 || isBound || !isInAnalysis || operation?.document?.idDomainStatus === 20 || operation?.document?.idDomainStatus === 16 || (!permissions.NBI_REQUEST_APPROVE_REJECT && operation?.document?.idDomainStatus === 19)}
                      disabledCommision={isBound || (isInAnalysis && !permissions.NBI_REQUEST_APPROVE_REJECT) || (isInAnalysis && (operation?.document?.idDomainStatus === 20 || operation?.document?.idDomainStatus === 16))}
                      permissions={permissions}
                      idOperation={props.match?.params?.idOperation}
                      idProduct={props.match?.params?.idProduct}
                      susepProcess={operation?.susepProcess || '-'}
                      disabledConfirm={
                        ((!permissions.ORDER_TO_BIND_GENERATE && operation?.idDomain == 26)
                          || (!permissions.ROUTE_POLICIES_CREATE_ENDORSEMENT && operation?.idDomain !== 26))
                        || isBound || (operation?.document?.idDomainStatus !== 16 && operation?.document?.idDomainStatus !== 20)}
                      theadBackgroundColor={Colors.PRIMARY1}
                      onConfirmPlanText={'CONTRATAR'}
                      customButton={[Colors.WHITE, Colors.TERTIARY]}
                      showHistory={previousCoverageCalcList?.length}
                      showCoveragesAndExtensions={permissions.NBI_REQUEST_APPROVE_REJECT}
                      onConfirmPlan={async (index) => {
                        try {
                          const allowedOperationAmount = await handleCheckMaxOperationAmount();
                          if (!allowedOperationAmount) return;
                          const canConsumeLimite = await handleCheckConsumption();
                          if (!canConsumeLimite) return;
                          const totalPaidValidation = handleTotalPaidValidationEndorsements();
                          if (!totalPaidValidation) return;
                          const verifiedPaymentToRefund = await handleVerifyPaymentOfEndorsementsToRefund(fullCoverageList);
                          if (!verifiedPaymentToRefund) return;
                          const questionnaireData = handleSaveQuestionnaireAnswer(null, true);
                          await useSaveQuestionnaireAnswerSyncRequest(questionnaireData);
                          await useGetQuestionnairesAnswersRequest(null, { idDomainStatus: operation?.idDomainStatus }).then(() => { });
                          await useUpdateOperationRequest({ operationMetadata: { ...operation?.operationMetadata, coverageOption: index, idProductPlanSelected: idProductPlan } });
                          await useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, questionMappingAdhoc: questionMappingAdhocParameters.current, idProductPlanSelected: idProductPlan }, { draft: false });
                          await useUpdateDocumentsClausesRequest({ selectedClauses }, { idDomainDocument: 261 });

                          const hasInternalProcessNumberAnswer = questionnaire.find(qst => qst.idQuestion === 3476)?.answer;
                          if (!hasInternalProcessNumberAnswer) {
                            await useRequestSompoGetInternalProcessNumberRequest({ idOperation: operation?.idOperation })
                              .then(async (response) => {
                                if (response.status !== 200) {
                                  return mc.error('Ocorreu um erro na requisição do sistema externo');
                                }
                                await useGenerateQuoteRequest({ selectedClausesAdHock: selectedClauses, idDomainStatus: 20, idProductPlanSelected: idProductPlan });
                                history.push({ pathname: `/payment-configuration/${props.match?.params?.idOperation}`, state: { option: index, idProductPlanSelected: idProductPlan } });
                              }).catch((e) => {
                                return mc.error('Ocorreu um erro na requisição do sistema externo');
                              })
                          } else {
                            await useGenerateQuoteRequest({ selectedClausesAdHock: selectedClauses, idDomainStatus: 20, idProductPlanSelected: idProductPlan });
                            history.push({ pathname: `/payment-configuration/${props.match?.params?.idOperation}`, state: { option: index, idProductPlanSelected: idProductPlan } });
                          }
                        } catch (e) {
                          console.log("error", e);
                          loading.stop();
                          return mc.error('Falha ao confirmar a sua cotação, tente novamente!')
                        }
                      }}
                      onRecalculate={(value, index, fieldName) => {
                        const hasParameter = recalculateParameters.current.find((option) => option.coverageCalcIndex === index);

                        if (hasParameter) {
                          hasParameter[fieldName] = value;
                        } else {
                          recalculateParameters.current.push({ coverageCalcIndex: index, [fieldName]: value })
                        }
                        useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, questionMappingAdhoc: questionMappingAdhocParameters.current, idProductPlanSelected: idProductPlan }, { draft: true });
                      }}
                      handleCheckCoverage={(value, index, idCoverage) => {
                        const hasParameter = recalculateParameters.current.find((option) => option.coverageCalcIndex === index);

                        if (hasParameter) {
                          if (hasParameter.coveragesDisabled) {
                            hasParameter.coveragesDisabled = hasParameter.coveragesDisabled.filter((idCov) => idCov.idCoverage != idCoverage);
                            hasParameter.coveragesDisabled.push({ idCoverage, value });
                          } else if (value) {
                            hasParameter.coveragesDisabled = [{ idCoverage, value }];
                          }
                        } else {
                          recalculateParameters.current.push({ coverageCalcIndex: index, coveragesDisabled: [{ idCoverage, value }] })
                        }

                        useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, questionMappingAdhoc: questionMappingAdhocParameters.current, idProductPlanSelected: idProductPlan }, { draft: true });
                      }}
                      onRecalculateItem={(value, index, idCoverage, fieldName, resetFieldName = 'dummyField') => {
                        const hasParameter = recalculateParameters.current.find((option) => option.coverageCalcIndex === index);
                        if (hasParameter) {
                          if (hasParameter.coverageItens) {
                            const hasCoverage = hasParameter.coverageItens.find((coverage) => coverage.idCoverage === idCoverage);
                            if (hasCoverage) {
                              hasCoverage[fieldName] = value;
                              hasCoverage[resetFieldName] = null;
                            } else {
                              hasParameter.coverageItens.push({ idCoverage, [fieldName]: value, [resetFieldName]: null })
                            }
                          } else {
                            hasParameter.coverageItens = [{ idCoverage, [fieldName]: value, [resetFieldName]: null }];
                          }
                        } else {
                          recalculateParameters.current.push({ coverageCalcIndex: index, coverageItens: [{ idCoverage, [fieldName]: value, [resetFieldName]: null }] })
                        }
                        useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, questionMappingAdhoc: questionMappingAdhocParameters.current, idProductPlanSelected: idProductPlan }, { draft: true });
                      }}
                      openHistoryModel={(index) => {
                        setSelectedOption(index)
                      }}
                      onSelectDeductible={(value) => handleSelectDeductible(value)}
                      onOptionsDeductible={groupDeductible}
                      onChoosedDeductible={choosedDeductible}
                      hasCoverageCalc={hasCoverageCalc}
                      minComission={minCommissionValue}
                      maxComission={maxComissionValue}
                      creditLimits={creditLimits}
                    />

                    : <Table
                      componentTypeRender="sompoProductPlan"
                      tomadorInfo={tomadorInfo}
                      formikValues={values}
                      formikRef={formikRef}
                      calcList={coverageCalcList.filter(calculations => calculations.coverageLimit)}
                      setFieldValue={setFieldValue}
                      history={history}
                      showAlterButton={isBound}
                      warrantyQuote
                      disabled={operation?.idDomain === 400 || isBound || !isInAnalysis || operation?.document?.idDomainStatus === 20 || operation?.document?.idDomainStatus === 16 || (!permissions.NBI_REQUEST_APPROVE_REJECT && operation?.document?.idDomainStatus === 19)}
                      newDisabled={operation?.idDomain === 400 || isBound || !isInAnalysis || operation?.document?.idDomainStatus === 20 || operation?.document?.idDomainStatus === 16 || (!permissions.NBI_REQUEST_APPROVE_REJECT && operation?.document?.idDomainStatus === 19)}
                      disabledCommision={
                        operation?.idDomain === 400 ||
                        authContext?.username === "poc_sompo_tomador@fitisur.com.br" ||
                        isBound || (isInAnalysis && !permissions.NBI_REQUEST_APPROVE_REJECT) || (isInAnalysis && (operation?.document?.idDomainStatus === 20 || operation?.document?.idDomainStatus === 16))}
                      permissions={permissions}
                      idOperation={props.match?.params?.idOperation}
                      idProduct={props.match?.params?.idProduct}
                      susepProcess={operation?.susepProcess || '-'}
                      disabledConfirm={
                        ((!permissions.ORDER_TO_BIND_GENERATE && operation?.idDomain == 26)
                          || (!permissions.ROUTE_POLICIES_CREATE_ENDORSEMENT && operation?.idDomain !== 26))
                        || isBound || (operation?.document?.idDomainStatus !== 16 && operation?.document?.idDomainStatus !== 20)}
                      onConfirmPlanText={'CONTRATAR'}
                      customButton={[Colors.WHITE, Colors.TERTIARY]}
                      theadBackgroundColor={Colors.PRIMARY1}
                      showHistory={previousCoverageCalcList?.length}
                      showCoveragesAndExtensions={permissions.NBI_REQUEST_APPROVE_REJECT}
                      onConfirmPlan={async (index) => {
                        buildValidation().validate(values, { abortEarly: false })
                          .then(async () => {
                            try {
                              const allowedOperationAmount = await handleCheckMaxOperationAmount();
                              if (!allowedOperationAmount) return;
                              const canConsumeLimite = await handleCheckConsumption();
                              if (!canConsumeLimite) return;
                              const totalPaidValidation = handleTotalPaidValidationEndorsements();
                              if (!totalPaidValidation) return;
                              const verifiedPaymentToRefund = await handleVerifyPaymentOfEndorsementsToRefund(fullCoverageList);
                              if (!verifiedPaymentToRefund) return;
                              const questionnaireData = handleSaveQuestionnaireAnswer(null, true);
                              await useSaveQuestionnaireAnswerSyncRequest(questionnaireData);
                              await useGetQuestionnairesAnswersRequest(null, { idDomainStatus: operation?.idDomainStatus }).then(() => { });
                              await useUpdateOperationRequest({ operationMetadata: { ...operation?.operationMetadata, coverageOption: index, idProductPlanSelected: idProductPlan } });
                              await useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, questionMappingAdhoc: questionMappingAdhocParameters.current, idProductPlanSelected: idProductPlan }, { draft: false });
                              await useUpdateDocumentsClausesRequest({ selectedClauses }, { idDomainDocument: 261 });

                              const hasInternalProcessNumberAnswer = questionnaire.find(qst => qst.idQuestion === 3476)?.answer;
                              if (!hasInternalProcessNumberAnswer) {
                                await useRequestSompoGetInternalProcessNumberRequest({ idOperation: operation?.idOperation })
                                  .then(async (response) => {
                                    if (response.status !== 200) {
                                      return mc.error('Ocorreu um erro na requisição do sistema externo');
                                    }
                                    await useGenerateQuoteRequest({ selectedClausesAdHock: selectedClauses, idDomainStatus: 20, idProductPlanSelected: idProductPlan });
                                    history.push({ pathname: `/payment-configuration/${props.match?.params?.idOperation}`, state: { option: index, idProductPlanSelected: idProductPlan } });
                                  }).catch((e) => {
                                    return mc.error('Ocorreu um erro na requisição do sistema externo');
                                  })
                              } else {
                                await useGenerateQuoteRequest({ selectedClausesAdHock: selectedClauses, idDomainStatus: 20, idProductPlanSelected: idProductPlan });
                                history.push({ pathname: `/payment-configuration/${props.match?.params?.idOperation}`, state: { option: index, idProductPlanSelected: idProductPlan } });
                              }

                            } catch (e) {
                              console.log("error", e);
                              loading.stop();
                              return mc.error('Falha ao confirmar a sua cotação, tente novamente!')
                            }
                          })
                          .catch((e) => {
                            onValidationError(e, mc, formikRef, questionnaire, [])
                          })
                      }}
                      onRecalculate={(value, index, fieldName) => {
                        const hasParameter = recalculateParameters.current.find((option) => option.coverageCalcIndex === index);

                        if (hasParameter) {
                          hasParameter[fieldName] = value;
                        } else {
                          recalculateParameters.current.push({ coverageCalcIndex: index, [fieldName]: value })
                        }
                        useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, questionMappingAdhoc: questionMappingAdhocParameters.current, idProductPlanSelected: idProductPlan }, { draft: true });
                      }}
                      handleCheckCoverage={(value, index, idCoverage) => {
                        const hasParameter = recalculateParameters.current.find((option) => option.coverageCalcIndex === index);

                        if (hasParameter) {
                          if (hasParameter.coveragesDisabled) {
                            hasParameter.coveragesDisabled = hasParameter.coveragesDisabled.filter((idCov) => idCov.idCoverage != idCoverage);
                            hasParameter.coveragesDisabled.push({ idCoverage, value });
                          } else if (value) {
                            hasParameter.coveragesDisabled = [{ idCoverage, value }];
                          }
                        } else {
                          recalculateParameters.current.push({ coverageCalcIndex: index, coveragesDisabled: [{ idCoverage, value }] })
                        }

                        useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, questionMappingAdhoc: questionMappingAdhocParameters.current, idProductPlanSelected: idProductPlan }, { draft: true });
                      }}
                      onRecalculateItem={(value, index, idCoverage, fieldName, resetFieldName = 'dummyField') => {
                        const hasParameter = recalculateParameters.current.find((option) => option.coverageCalcIndex === index);
                        if (hasParameter) {
                          if (hasParameter.coverageItens) {
                            const hasCoverage = hasParameter.coverageItens.find((coverage) => coverage.idCoverage === idCoverage);
                            if (hasCoverage) {
                              hasCoverage[fieldName] = value;
                              hasCoverage[resetFieldName] = null;
                            } else {
                              hasParameter.coverageItens.push({ idCoverage, [fieldName]: value, [resetFieldName]: null })
                            }
                          } else {
                            hasParameter.coverageItens = [{ idCoverage, [fieldName]: value, [resetFieldName]: null }];
                          }
                        } else {
                          recalculateParameters.current.push({ coverageCalcIndex: index, coverageItens: [{ idCoverage, [fieldName]: value, [resetFieldName]: null }] })
                        }

                        if (fieldName === 'customCoverageRate') {
                          const hasParameter = recalculateParameters.current.find((option) => option.coverageCalcIndex === index);
                          hasParameter.idProductPlan = idProductPlan;
                          for (const item of hasParameter.coverageItens) {
                            if (item.idCoverage !== idCoverage) continue;
                            if (!item.coverageMappingAdhoc) item.coverageMappingAdhoc = []

                            const hasCoverageMappingAdhoc = item.coverageMappingAdhoc.find(
                              item => item.mapName === 'PRODUCT_PLAN_COVERAGE.COVERAGE_RATE'
                            );

                            if (hasCoverageMappingAdhoc) {
                              hasCoverageMappingAdhoc.mapValue = parseFloat(value || 0);
                            } else {
                              item.coverageMappingAdhoc.push({
                                mapName: 'PRODUCT_PLAN_COVERAGE.COVERAGE_RATE', mapValue: parseFloat(value || 0)
                              });
                            }
                          }
                        }

                        useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, questionMappingAdhoc: questionMappingAdhocParameters.current, idProductPlanSelected: idProductPlan }, { draft: true });
                      }}
                      openHistoryModel={(index) => {
                        setSelectedOption(index)
                      }}
                      onSelectDeductible={(value) => handleSelectDeductible(value)}
                      onOptionsDeductible={groupDeductible}
                      onChoosedDeductible={choosedDeductible}
                      hasCoverageCalc={hasCoverageCalc}
                      minComission={minCommissionValue}
                      maxComission={maxComissionValue}
                      isInAnalysis={isInAnalysis}
                      creditLimits={creditLimits}
                    />}
                </CoverageContainer>

                <div style={{ marginLeft: 15, marginRight: 15 }}>
                  <FormSection
                    sectionName="PLANS"
                    questionnaire={questionnaire}
                    setQuestionnaire={setQuestionnaire}
                    values={values}
                    errors={errors}
                    setFieldValue={setFieldValue}
                    setFieldError={setFieldError}
                    disableAll={isBound || finishedAnalysis}
                    ignoreModality
                    idProduct={props.match.params.idProduct}
                    idOperation={props.match.params.idOperation}
                    permissions={permissions}
                    onBlur={async (
                      question,
                      value,
                      setFieldValue,
                      questionnaireUpdated
                    ) => {
                      let questionnaireUpdatedAux = cloneDeep(questionnaireUpdated)
                      questionnaireUpdatedAux = questionnaireUpdatedAux.map(qst => {
                        if (question.idQuestion === 1842 && qst.idQuestion === question.idQuestion) {
                          qst.answer = value;
                        }
                        return qst;
                      })

                      if (question.idQuestion === 1842) {
                        handleCalculateCancellation(questionnaireUpdatedAux, coverageCalcList);
                      }
                    }}
                    extraButtonsQuestion={(question) => {
                      if (question.idQuestion !== 1842) return null;
                      if (operation.idDomain !== 400 && operation.idDomain !== 398) return null;

                      return (
                        <RefreshButon type="button" onClick={() => handleCalculateCancellation(questionnaire, coverageCalcList, true)}>
                          <Icon name='generate' title='Consultar Parcelas' />
                        </RefreshButon>
                      )
                    }}
                    onQuestionChange={async (
                      question,
                      value,
                      setFieldValue,
                      questionnaireUpdated
                    ) => {
                      let questionnaireUpdatedAux = cloneDeep(questionnaireUpdated)
                      questionnaireUpdatedAux = questionnaireUpdatedAux.map(qst => {
                        if (question.idQuestion === 1856 && qst.idQuestion === question.idQuestion) {
                          qst.answer = value?.dsAnswerOption;
                          qst.idAnswerOption = value?.idAnswerOption;
                        } else if (question.idQuestion === 1833 && qst.idQuestion === question.idQuestion) {
                          qst.answer = value;
                        } else if (question.idQuestion === 2437 && qst.idQuestion === question.idQuestion) {
                          qst.answer = value?.dsAnswerOption;
                          qst.idAnswerOption = value?.idAnswerOption;
                        }
                        return qst;
                      })

                      if ([1856, 2437].includes(question.idQuestion)) {
                        if (operation.idDomain === 398 && question.idQuestion === 2437) {
                          const disregardMinimumPremium = value?.idAnswerOption === 8158;
                          useRecalculateSyncRequest(
                            {
                              recalculateParameters: recalculateParameters.current,
                              questionMappingAdhoc: questionMappingAdhocParameters.current,
                              idProductPlanSelected: idProductPlan,
                              disregardMinimumPremium
                            },
                            { draft: true }
                          );
                        } else {
                          handleCalculateCancellation(questionnaireUpdatedAux, coverageCalcList)
                        }
                      }
                    }}
                  />

                  <FormSection
                    sectionName="PLANS_PAYMENT"
                    questionnaire={questionnaire}
                    setQuestionnaire={setQuestionnaire}
                    values={values}
                    errors={errors}
                    setFieldValue={setFieldValue}
                    setFieldError={setFieldError}
                    disableAll={isBound}
                    ignoreModality
                    idProduct={props.match.params.idProduct}
                    idOperation={props.match.params.idOperation}
                    permissions={permissions}
                    onQuestionChange={(
                      question,
                      value,
                      setFieldValue,
                      questionnaireUpdated
                    ) => {

                    }}
                  />
                </div>

                <div style={{
                  // display: permissions.NBI_REQUEST_APPROVE_REJECT ? "block" : "none",
                  marginLeft: 15,
                  marginRight: 15,
                  marginTop: 25
                }}>
                  {coverageCalcList.map(calc => {
                    if (calc?.idProductPlan) {
                      return (
                        <Clauses
                          idOperation={operation?.idOperation}
                          idProduct={calc.idProduct || operation?.idProduct}
                          idProductPlan={calc.idProductPlan}
                          isInAnalysis={isInAnalysis}
                          permission={handlePermissionEdit()}
                          isLoading={(isLoading) => setClausesLoading(isLoading)}
                          onSelectClauses={(onSelectClauses) => {
                            setSelectedClauses(onSelectClauses)
                          }}
                          reloadClauses={reloadClauses}
                          overwriteQstValues={overwriteQstValues}
                          clauseVersionNumber={questionnaire.find(qst => [1562, 1702].includes(qst.idQuestion) && qst?.answer)?.answer}
                        />
                      )
                    }
                    return <></>;
                  })}
                </div>

                <HasPermission permission={permissions.NBI_REQUEST_APPROVE_REJECT && isInAnalysis}>
                  <div style={{ marginLeft: 15, marginRight: 15 }}>
                    <FormSection
                      sectionName="QUOTE_LETTER"
                      questionnaire={questionnaire}
                      setQuestionnaire={setQuestionnaire}
                      values={values}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      setFieldError={setFieldError}
                      disableAll={isBound}
                      ignoreModality
                      idProduct={props.match.params.idProduct}
                      permissions={permissions}
                      onQuestionChange={(
                        question,
                        value,
                        setFieldValue,
                        questionnaireUpdated
                      ) => {
                        if (question?.idQuestion !== 1603 && !value?.idAnswerOption) return;

                        let idDomainStatus = value?.idAnswerOption === 7221 ? 19 : 16;

                        setOperation({
                          ...operation, document: {
                            ...operation.document,
                            idDomainStatus
                          }
                        });
                      }}
                    />
                  </div>
                </HasPermission>


                {/* <HasPermission permission={isInAnalysis}>
                  <div style={{ padding: '10px', width: '100%' }}>
                    <FormSection
                      sectionName="QUOTE_LETTER"
                      disableAll={isBound}
                      questionnaire={questionnaire}
                      values={values}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      setFieldError={setFieldError}
                      ignoreModality
                      permissions={permissions}
                      idProduct={props.match.params.idProduct}
                    />
                  </div>
                </HasPermission> */}

                <Row>
                  <Col>
                  </Col>
                </Row>

                <ButtonContainer style={{ padding: '0 10px' }}>
                  <Button forth style={{ width: 'auto' }} onClick={() => handleBack()}> &lt; VOLTAR </Button>
                  <ButtonContent>
                    <HasPermission permission={!isBound}>
                      {(operation?.idOperation) && 
                      <HasPermission permission={permissions.CANCEL_ENQUIRY}>
                        <LostCancelButton idQuestion={1429} idOperation={props.match?.params?.idOperation} title={'PERDIDO'} idDomain={operation?.idDomain} redirectTo={"/list"} />
                      </HasPermission>}

                      <HasPermission
                        permission={
                          isInAnalysis &&
                          operation?.idOperation && operation?.idProduct != 48 &&
                          [8, 10, 443, 444, 445].includes(operation?.idDomainStatus) &&
                          permissions.REQUEST_ADDITIONAL_INFO
                        }
                      >
                        <Button
                          type="button"
                          onClick={() => setNotesModal(true)}
                          third
                        >
                          MAIS INFO
                        </Button>
                      </HasPermission>

                      <HasPermission
                        permission={
                          isInAnalysis &&
                          operation?.idOperation &&
                          [8, 10, 116, 126, 141, 151, 178, 384, 443, 444, 445].includes(operation?.idDomainStatus) &&
                          permissions.NBI_REQUEST_APPROVE_REJECT
                        }
                      >
                        <Button
                          id="btnContinue"
                          type="button"
                          onClick={() => {
                            validationSchema.current.validate(values)
                              .then(async () => {
                                try {
                                  await useUpdateOperationRequest({ operationMetadata: { ...operation?.operationMetadata, idProductPlanSelected: idProductPlan } });
                                  await useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, questionMappingAdhoc: questionMappingAdhocParameters.current, idProductPlanSelected: idProductPlan }, { draft: false });
                                  await useUpdateDocumentsClausesRequest({ selectedClauses }, { idDomainDocument: 261 });
                                  goToNextPage.current = false;
                                  handleSaveQuestionnaireAnswer(props.match?.params?.idOperation)
                                } catch (e) {
                                  console.log("error", e);
                                  loading.stop();
                                  return mc.error('Falha ao confirmar a sua cotação, tente novamente!')
                                }
                              })
                              .catch((e) => {
                                console.log('validation error', e)
                              })
                          }}
                          style={{ marginLeft: 15 }}
                          custom={[Colors.WHITE, Colors.TERTIARY]}
                        >
                          SALVAR
                        </Button>
                      </HasPermission>
                      <HasPermission permission={!isInAnalysis && permissions.GENERATE_MRC}>
                        <Button
                          id="btnContinue"
                          type="button"
                          onClick={() => {
                            buildValidation().validate(values, { abortEarly: false })
                              .then(async () => {
                                try {
                                  const allowedOperationAmount = await handleCheckMaxOperationAmount();
                                  if (!allowedOperationAmount) return;
                                  const canConsumeLimite = await handleCheckConsumption();
                                  if (!canConsumeLimite) return;
                                  const totalPaidValidation = handleTotalPaidValidationEndorsements();
                                  if (!totalPaidValidation) return;
                                  const verifiedPaymentToRefund = await handleVerifyPaymentOfEndorsementsToRefund(fullCoverageList);
                                  if (!verifiedPaymentToRefund) return;
                                  const questionnaireData = handleSaveQuestionnaireAnswer(null, true);
                                  await useSaveQuestionnaireAnswerSyncRequest(questionnaireData);
                                  await useGetQuestionnairesAnswersRequest(null, { idDomainStatus: operation?.idDomainStatus }).then(() => { });
                                  await useUpdateOperationRequest({ operationMetadata: { ...operation?.operationMetadata, idProductPlanSelected: idProductPlan } });
                                  await useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, questionMappingAdhoc: questionMappingAdhocParameters.current, idProductPlanSelected: idProductPlan }, { draft: false });
                                  await useUpdateDocumentsClausesRequest({ selectedClauses }, { idDomainDocument: 261 });
                                  const hasInternalProcessNumberAnswer = questionnaire.find(qst => qst.idQuestion === 3476)?.answer;
                                  if (!hasInternalProcessNumberAnswer) {
                                    await useRequestSompoGetInternalProcessNumberRequest({ idOperation: operation?.idOperation })
                                      .then(async (response) => {
                                        if (response.status !== 200) {
                                          return mc.error('Ocorreu um erro na requisição do sistema externo');
                                        }
                                        await useGenerateQuoteRequest({ selectedClausesAdHock: selectedClauses, idDomainStatus: 16, idProductPlanSelected: idProductPlan })
                                        return history.push(`/quote/document/${operation?.idProduct}/${props?.match?.params?.idOperation}`);
                                      }).catch((e) => {
                                        return mc.error('Ocorreu um erro na requisição do sistema externo');
                                      })
                                  } else {
                                    await useGenerateQuoteRequest({ selectedClausesAdHock: selectedClauses, idDomainStatus: 16, idProductPlanSelected: idProductPlan })
                                    return history.push(`/quote/document/${operation?.idProduct}/${props?.match?.params?.idOperation}`);
                                  }
                                } catch (e) {
                                  console.log("error", e);
                                  loading.stop();
                                  return mc.error('Falha ao confirmar a sua cotação, tente novamente!')
                                }
                              })
                              .catch((e) => {
                                onValidationError(e, mc, formikRef, questionnaire, [])
                              })
                          }}
                          style={{ marginLeft: 15 }}
                          custom={[Colors.WHITE, Colors.TERTIARY]}
                        >
                          {
                            operation?.idDomain == 254 || operation?.idDomain == 398 || operation?.idDomain == 400 ? `${permissions.NBI_REQUEST_APPROVE_REJECT ? "GERAR" : "SOLICITAR"} ENDOSSO` : "GERAR COTAÇÃO"
                          }
                        </Button>
                      </HasPermission>
                      <HasPermission permission={(isInAnalysis && permissions.NBI_REQUEST_APPROVE_REJECT) && permissions.GENERATE_MRC}>
                        <Button
                          id="btnContinue"
                          type="button"
                          onClick={() => {
                            buildValidation().validate(values, { abortEarly: false })
                              .then(async () => {
                                try {
                                  const allowedOperationAmount = await handleCheckMaxOperationAmount();
                                  if (!allowedOperationAmount) return;
                                  const canConsumeLimite = await handleCheckConsumption();
                                  if (!canConsumeLimite) return;
                                  const totalPaidValidation = handleTotalPaidValidationEndorsements();
                                  if (!totalPaidValidation) return;
                                  const verifiedPaymentToRefund = await handleVerifyPaymentOfEndorsementsToRefund(fullCoverageList);
                                  if (!verifiedPaymentToRefund) return;
                                  await useUpdateOperationRequest({ operationMetadata: { ...operation?.operationMetadata, idProductPlanSelected: idProductPlan } });
                                  await useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, questionMappingAdhoc: questionMappingAdhocParameters.current, idProductPlanSelected: idProductPlan }, { draft: false });
                                  await useUpdateDocumentsClausesRequest({ selectedClauses }, { idDomainDocument: 261 });
                                  const hasInternalProcessNumberAnswer = questionnaire.find(qst => qst.idQuestion === 3476)?.answer;
                                  if (!hasInternalProcessNumberAnswer) {
                                    await useRequestSompoGetInternalProcessNumberRequest({ idOperation: operation?.idOperation })
                                      .then(async (response) => {
                                        if (response.status !== 200) {
                                          return mc.error('Ocorreu um erro na requisição do sistema externo');
                                        }
                                        goToNextPage.current = true;
                                        await handleGenerateQuote(values)
                                      }).catch((e) => {
                                        return mc.error('Ocorreu um erro na requisição do sistema externo');
                                      })
                                  } else {
                                    goToNextPage.current = true;
                                    await handleGenerateQuote(values)
                                  }

                                } catch (e) {
                                  console.log("error", e);
                                  loading.stop();
                                  return mc.error('Falha ao confirmar a sua cotação, tente novamente!')
                                }
                              })
                              .catch((e) => {
                                onValidationError(e, mc, formikRef, questionnaire, [])
                              })
                          }}
                          style={{ marginLeft: 15 }}
                          custom={[Colors.WHITE, Colors.TERTIARY]}
                        >
                          {
                            operation?.idDomain == 254 || operation?.idDomain == 398 || operation?.idDomain == 400 ? `${permissions.NBI_REQUEST_APPROVE_REJECT ? "GERAR" : "SOLICITAR"} ENDOSSO` : "GERAR COTAÇÃO"
                          }
                        </Button>
                      </HasPermission>
                    </HasPermission>
                  </ButtonContent>
                </ButtonContainer>
              </Form>
            )
          }}
        </Formik>
      </Content>
    </Layout >
  )
}
